import React from 'react';
import { Typography } from '@mui/material';

const MissingBookingInfo = () => {
  return (
    <div>
      <Typography
        style={{
          fontWeight: 'bold',
          marginBottom: '14px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          paddingTop: '100px',
          fontSize: '20px',
        }}
      >
        Please Contact Front Desk
      </Typography>
    </div>
  );
};

export default MissingBookingInfo;
